import { render } from "./RiplayUmum.vue?vue&type=template&id=4985f524"
import script from "./RiplayUmum.vue?vue&type=script&lang=js"
export * from "./RiplayUmum.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__